var _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1165,
    height: 866,
    viewBox: "0 0 1165 866",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 407,
    y: 91,
    width: 682,
    height: 856
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M868.151 287.761C851.873 281.719 839.793 268.405 835.301 251.639C803.026 131.19 675.217 61.8741 555.249 103.004C455.221 137.373 394.027 240.781 412.512 345.064C416.572 369.039 424.366 391.068 435.335 410.827C444.594 427.734 445.825 448.212 437.695 465.522C405.209 536.648 397.187 619.66 420.941 701.252C472.232 878.554 658.695 983.225 837.148 934.463C1017.81 885.11 1124.92 698.938 1076.45 518.043C1047.01 408.182 967.176 325.54 868.151 287.761Z",
    fill: "url(#paint0_linear_2005_216)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_216)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.151 287.761C851.873 281.719 839.793 268.405 835.301 251.639C803.026 131.19 675.217 61.8741 555.249 103.004C455.221 137.373 394.027 240.781 412.512 345.064C416.572 369.039 424.366 391.068 435.335 410.827C444.594 427.734 445.825 448.212 437.695 465.522C405.209 536.648 397.187 619.66 420.941 701.252C472.232 878.554 658.695 983.225 837.148 934.463C1017.81 885.11 1124.92 698.938 1076.45 518.043C1047.01 408.182 967.176 325.54 868.151 287.761Z",
    fill: "url(#paint1_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.151 287.761C851.873 281.719 839.793 268.405 835.301 251.639C803.026 131.19 675.217 61.8741 555.249 103.004C455.221 137.373 394.027 240.781 412.512 345.064C416.572 369.039 424.366 391.068 435.335 410.827C444.594 427.734 445.825 448.212 437.695 465.522C405.209 536.648 397.187 619.66 420.941 701.252C472.232 878.554 658.695 983.225 837.148 934.463C1017.81 885.11 1124.92 698.938 1076.45 518.043C1047.01 408.182 967.176 325.54 868.151 287.761Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2005_216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 231,
    width: 500,
    height: 449
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.835 474.508C153.407 583.317 254.027 660.612 363.657 649.964C364.263 649.742 365.284 649.711 365.699 649.903C406.029 645.423 445.898 652.809 482.788 669.891C503.512 679.487 527.722 682.643 552.263 676.389C599.94 664.739 633.555 620.405 632.085 571.401C631.135 539.753 616.206 512.202 593.993 493.863C570.728 474.533 555.416 447.812 551.657 417.883C551.626 416.862 551.181 415.65 551.342 414.214C536.235 298.996 431.408 217.739 316.19 232.847C199.122 247.601 116.967 356.542 135.835 474.508Z",
    fill: "url(#paint2_linear_2005_216)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2005_216)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.835 474.508C153.407 583.317 254.027 660.612 363.657 649.964C364.263 649.742 365.284 649.711 365.699 649.903C406.029 645.423 445.898 652.809 482.788 669.891C503.512 679.487 527.722 682.643 552.263 676.389C599.94 664.739 633.555 620.405 632.085 571.401C631.135 539.753 616.206 512.202 593.993 493.863C570.728 474.533 555.416 447.812 551.657 417.883C551.626 416.862 551.181 415.65 551.342 414.214C536.235 298.996 431.408 217.739 316.19 232.847C199.122 247.601 116.967 356.542 135.835 474.508Z",
    fill: "url(#paint3_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.835 474.508C153.407 583.317 254.027 660.612 363.657 649.964C364.263 649.742 365.284 649.711 365.699 649.903C406.029 645.423 445.898 652.809 482.788 669.891C503.512 679.487 527.722 682.643 552.263 676.389C599.94 664.739 633.555 620.405 632.085 571.401C631.135 539.753 616.206 512.202 593.993 493.863C570.728 474.533 555.416 447.812 551.657 417.883C551.626 416.862 551.181 415.65 551.342 414.214C536.235 298.996 431.408 217.739 316.19 232.847C199.122 247.601 116.967 356.542 135.835 474.508Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.694 322.579C980.737 298.69 949.731 283.86 956.313 253.476C957.051 247.763 959.044 242.101 961.96 237.155C964.85 232.004 968.842 227.339 973.782 223.595C978.723 219.851 984.228 217.285 990.067 215.717C995.905 214.15 1001.69 213.837 1007.41 214.575C1040.61 228.712 1072.41 266.338 1074.82 303.707C1074.11 309.625 1072.3 315.057 1069.2 320.234C1066.31 325.385 1062.32 330.05 1057.38 333.794C1052.44 337.538 1046.93 340.104 1041.1 341.671C1035.46 343.213 1029.44 343.346 1023.73 342.608C1017.99 341.665 1012.1 339.493 1006.87 335.988C1001.64 332.484 996.694 327.903 992.694 322.579Z",
    fill: "url(#paint4_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.694 322.579C980.737 298.69 949.731 283.86 956.313 253.476C957.051 247.763 959.044 242.101 961.96 237.155C964.85 232.004 968.842 227.339 973.782 223.595C978.723 219.851 984.228 217.285 990.067 215.717C995.905 214.15 1001.69 213.837 1007.41 214.575C1040.61 228.712 1072.41 266.338 1074.82 303.707C1074.11 309.625 1072.3 315.057 1069.2 320.234C1066.31 325.385 1062.32 330.05 1057.38 333.794C1052.44 337.538 1046.93 340.104 1041.1 341.671C1035.46 343.213 1029.44 343.346 1023.73 342.608C1017.99 341.665 1012.1 339.493 1006.87 335.988C1001.64 332.484 996.694 327.903 992.694 322.579Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_diif_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.247 837.607C442.864 830.112 421.319 834.642 412.836 816.624C410.988 813.431 409.796 809.775 409.354 806.124C408.818 802.379 409.032 798.451 410.087 794.623C411.142 790.796 412.943 787.347 415.303 784.276C417.662 781.206 420.485 778.793 423.678 776.944C446.073 771.204 476.895 777.962 492.673 796.03C494.615 799.317 495.807 802.786 496.249 806.624C496.784 810.369 496.57 814.297 495.515 818.125C494.46 821.952 492.659 825.401 490.3 828.472C488.034 831.45 485.025 833.861 481.832 835.71C478.546 837.465 474.703 838.655 470.679 838.908C466.655 839.161 462.355 838.757 458.247 837.607Z",
    fill: "url(#paint5_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.247 837.607C442.864 830.112 421.319 834.642 412.836 816.624C410.988 813.431 409.796 809.775 409.354 806.124C408.818 802.379 409.032 798.451 410.087 794.623C411.142 790.796 412.943 787.347 415.303 784.276C417.662 781.206 420.485 778.793 423.678 776.944C446.073 771.204 476.895 777.962 492.673 796.03C494.615 799.317 495.807 802.786 496.249 806.624C496.784 810.369 496.57 814.297 495.515 818.125C494.46 821.952 492.659 825.401 490.3 828.472C488.034 831.45 485.025 833.861 481.832 835.71C478.546 837.465 474.703 838.655 470.679 838.908C466.655 839.161 462.355 838.757 458.247 837.607Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M842.184 751.139C908.369 751.139 962.024 697.485 962.024 631.299C962.024 565.113 908.369 511.459 842.184 511.459C775.998 511.459 722.344 565.113 722.344 631.299C722.344 697.485 775.998 751.139 842.184 751.139Z",
    fill: "url(#paint6_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.184 751.139C908.369 751.139 962.024 697.485 962.024 631.299C962.024 565.113 908.369 511.459 842.184 511.459C775.998 511.459 722.344 565.113 722.344 631.299C722.344 697.485 775.998 751.139 842.184 751.139Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.685 175.59C382.36 175.59 396.688 161.262 396.688 143.587C396.688 125.912 382.36 111.584 364.685 111.584C347.011 111.584 332.682 125.912 332.682 143.587C332.682 161.262 347.011 175.59 364.685 175.59Z",
    fill: "url(#paint7_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.685 175.59C382.36 175.59 396.688 161.262 396.688 143.587C396.688 125.912 382.36 111.584 364.685 111.584C347.011 111.584 332.682 125.912 332.682 143.587C332.682 161.262 347.011 175.59 364.685 175.59Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_diif_2005_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.159 170.11C724.482 196.436 772.027 191.575 798.353 159.252C824.68 126.929 819.819 79.384 787.496 53.0577C755.172 26.7314 707.628 31.5926 681.301 63.9157C654.975 96.2387 659.836 143.783 692.159 170.11Z",
    fill: "url(#paint8_radial_2005_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.159 170.11C724.482 196.436 772.027 191.575 798.353 159.252C824.68 126.929 819.819 79.384 787.496 53.0577C755.172 26.7314 707.628 31.5926 681.301 63.9157C654.975 96.2387 659.836 143.783 692.159 170.11Z",
    fill: "#1F7E37",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2005_216",
    x: 377.852,
    y: 91.1016,
    width: 752.414,
    height: 906.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -29.3625,
    dy: 51.3844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.3954
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 42.16,
    dy: 24.5928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_2005_216",
    result: "effect2_innerShadow_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_2005_216",
    x: 103.773,
    y: 231.039,
    width: 570.517,
    height: 518.986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 57.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -29.3625,
    dy: 51.3844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.3954
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 42.1591,
    dy: 24.5928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_2005_216",
    result: "effect3_innerShadow_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_2005_216",
    x: 917.508,
    y: 214.195,
    width: 211.729,
    height: 195.169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.8979,
    dy: 66.3214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.5331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 54.4143,
    dy: 31.7417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.7417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_2005_216",
    result: "effect2_innerShadow_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_diif_2005_216",
    x: 379.708,
    y: 754.808,
    width: 158.982,
    height: 154.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 57.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -29.3625,
    dy: 51.3844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.3954
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 42.1591,
    dy: 24.5928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_2005_216",
    result: "effect3_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.072,
    result: "effect4_foregroundBlur_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_2005_216",
    x: 692.981,
    y: 511.459,
    width: 311.202,
    height: 310.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 57.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -29.3625,
    dy: 51.3844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.3954
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 42.1591,
    dy: 24.5928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_2005_216",
    result: "effect3_innerShadow_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_2005_216",
    x: 324.841,
    y: 111.584,
    width: 75.2653,
    height: 82.806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.3819
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.84119,
    dy: 13.7221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2005_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_diif_2005_216",
    x: 634.98,
    y: 15.9556,
    width: 222.49,
    height: 241.513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 57.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_216",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -29.3625,
    dy: 51.3844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 62.3954
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 42.1591,
    dy: 24.5928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5928
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_2005_216",
    result: "effect3_innerShadow_2005_216"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.072,
    result: "effect4_foregroundBlur_2005_216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2005_216",
    x1: 855.548,
    y1: 1008.58,
    x2: 670.148,
    y2: 411.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.515679,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.2118 298.531 -435.897 727.923 484.45 47.3614)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2005_216",
    x1: 76.181,
    y1: 193.805,
    x2: 471.177,
    y2: 451.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119214,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.3452 139.573 -555.876 54.0655 420.597 207.638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-39.8728 7.32817 -90.6998 -107.822 1077.47 249.421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17.4273 19.2525 -88.1154 -19.5268 472.884 767.386)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.15654 85.3668 -214.599 161.397 803.566 491.897)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.10999 22.797 -57.3082 43.1006 354.373 106.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2005_216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-31.9259 43.3438 -169.001 -6.53882 776.417 28.1437)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidObject);
export default __webpack_public_path__ + "static/media/SolidObject.e44da4421ce9e1bf014e4903c61e25dd.svg";
export { ForwardRef as ReactComponent };